import { getAsset } from '@/assets/manifest';
import { Section } from '@/components/layout';
import { ResponsiveImage } from '@/components/media';
import { Reveal } from '@/components/motion';
import { GoldLine } from '@/components/ornaments';
import { Eyebrow } from '@/components/typography';
import { cancunMedia } from '../media';
import styles from './TarifasCancun.module.css';

const TITLE_ID = 'cancun-tarifas-hotel';

/**
 * PRECIOS DE LAS ESTANCIAS EN EL HOTEL PALMAÏA — encargo del cliente.
 *
 * Docx «Modificaciones en la web de eventoazrahel» (14-sep-2026): «PONER:
 * PRECIOS DE LAS ESTANCIAS, TARIFA: “TODO INCLUIDO”. Te paso el archivo en JPG».
 * Lo pidió en la ficha de la tienda y, confirmado después, también aquí.
 *
 * VA JUSTO DESPUÉS DE LA RESERVA porque es lo siguiente que necesita saber
 * quien va a apuntarse: la plaza NO incluye el hotel, y esto es lo que cuesta.
 *
 * LA TABLA ES LA IMAGEN DEL HOTEL, NO UNA TABLA MAQUETADA. Son precios de un
 * tercero: copiados a mano se desincronizan el día que el hotel los cambie, y
 * el cliente mandó el JPG para que se publique tal cual. Se puede abrir a
 * tamaño completo, que en móvil es como se lee una tabla de seis columnas.
 * Recortada la barra del visor PDF que traía la captura.
 */
export function TarifasCancun() {
  const tabla = getAsset(cancunMedia.hotelRates);

  return (
    <Section background="surface" labelledBy={TITLE_ID} width="default">
      <Reveal>
        <div className={styles.tarjeta}>
          <Eyebrow ink="gold">Hotel Palmaïa</Eyebrow>
          <h2 className={styles.titulo} id={TITLE_ID}>
            PRECIOS DE LAS ESTANCIAS, TARIFA: “TODO INCLUIDO”.
          </h2>
          <GoldLine ornament="diamond" width="sm" />
          <p className={styles.nota}>
            La plaza en la convivencia no incluye el hospedaje en el hotel: hay descuento para el grupo
            indicando «CONVIVENCIA CON AZRAHEL».
          </p>

          <figure className={styles.figura}>
            <a
              className={styles.enlace}
              href={tabla.src}
              target="_blank"
              rel="noopener"
              aria-label="Ver la tabla de tarifas del Hotel Palmaïa a tamaño completo (se abre en una pestaña nueva)"
            >
              <ResponsiveImage asset={cancunMedia.hotelRates} sizes="(min-width: 56rem) 52rem, 92vw" />
            </a>
            <figcaption className={styles.pie}>Pulsa la tabla para verla a tamaño completo.</figcaption>
          </figure>

          <p className={styles.contacto}>
            Contacto:{' '}
            <a href="https://wa.me/34722293967" target="_blank" rel="noopener">
              +34 722 29 39 67
            </a>{' '}
            Equipo de comunicación de Azrahel del Mayor.
          </p>
        </div>
      </Reveal>
    </Section>
  );
}
